import {Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {ApiService} from "../../../services/api.service";
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as _ from 'lodash';
import {ProfileListComponent} from "../profile-list/profile-list.component";
import {MODAL_CONFIG} from '../../../services/constant';


@Component({
  selector: 'profile-list-detail',
  templateUrl: './profile-list-detail.component.html',
  styleUrls: ['./profile-list-detail.component.scss']
})
export class ProfileListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  user: any = {};
  groups: any = [];
  companygroups: any = {};
  companyGroupID = [];
  title: string = '';
  createMode: boolean = false;
  errorMessage: string = null;
  passwordPlaceHolder: string = '';
  parent: ProfileListComponent = null;

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private modalService: BsModalService) {
  }

  open(parent: ProfileListComponent, selectedUser) {
    this.parent = parent;
    this.errorMessage = null;

    if (selectedUser != null) {
      this.user = _.cloneDeep(selectedUser);
      this.user.group = this.user.group.id;
      delete this.user.status;

      this.createMode = false;
      this.companyGroupID = [];
      this.title = "แก้ไขผู้ใช้งาน : " + this.user.username;
      this.passwordPlaceHolder = "(คลิกเพื่อเปลี่ยนรหัสผ่าน)"
      if (this.user.company_group) {
        this.user.company_group.forEach(what => {
          this.companyGroupID.push(what.id);
        });
      }
    } else {
      this.user = {"group": this.groups[0]['value']};
      this.createMode = true;
      this.title = "เพิ่มผู้ใช้งาน";
      this.passwordPlaceHolder = "รหัสผ่าน"
    }

    this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
  }

  ngOnInit() {
    this.loadGroups()
    this.loadCompanyGroups()
  }

  submit() {
    let errorField = [];
    this.errorMessage = null;

    if (this.user.username == null || this.user.username.length == 0)
      errorField.push("ชื่อผู้ใช้งาน");

    if (this.createMode && (this.user.password == null || this.user.password.length == 0))
      errorField.push("รหัสผ่าน");

    if (this.createMode && (this.companyGroupID == null || this.companyGroupID.length == 0))
      errorField.push("บริษัท");

    if (errorField.length > 0) {
      this.errorMessage = "โปรดกรอก" + errorField.join(',') + 'ให้ถูกต้อง';
      return;
    }

    this.user.company_group_id = this.companyGroupID;

    let request = null;
    if (this.createMode) {
      request = this.apiService.createUser(this.user);
      const role_name = this.groups.find(x => x.value === this.user.group).label;
      this.sniff('CREATE_USER', role_name + ': ' + this.user.username);
    } else {
      request = this.apiService.updateUser(this.user);
      this.sniff('UPDATE_USER', this.title + ' to ' + this.user.username);
    }


    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
        this.clearData();
      },
      error => {
        this.errorMessage = this.apiService.getErrorMessage(error);
        console.log('aa')
      }
    )
  }

  clearData() {
    this.user = {};
    this.companyGroupID = null;
  }

  disableUser() {
    this.sniff('DISABLE_USER', this.user.username);
    let request = this.apiService.deleteUser(this.user);
    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
      },
      error => {
        this.errorMessage = this.apiService.getErrorMessage(error);
        console.log('aa')
      }
    )
  }

  enableUser() {
    this.sniff('ENABLE_USER', this.user.username);
    this.user.is_active = true;
    let request = this.apiService.updateUser(this.user);

    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
      },
      error => {
        this.errorMessage = this.apiService.getErrorMessage(error);
      }
    )
  }

  loadGroups() {
    this.groups = [];

    this.apiService.getGroups().subscribe(
      (groups) => {
        _.forEach(groups, (group) => {
          this.groups.push({
            'label': group['name'],
            'value': group['id']
          })
        })
      },
      error => {
      }
    )
  }


  loadCompanyGroups() {
    this.companygroups = [];

    this.apiService.getCompanyGroups().subscribe(
      (companygroups) => {
        _.forEach(companygroups, (company_group) => {
          this.companygroups.push({
            'label': company_group['company_group'],
            'value': company_group['id']
          })
        })
      },
      error => {
        console.log('error', error)
      }
    )
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'MANAGE_USER',
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.ts